import {
  LotteryId,
  type Numbers,
} from '~~/@types/generated/backend/graphql-schema-types'

import type { LineItemField } from '~/components/LineItem/LineItem.vue'

export const getLotteryCssVarConstructor = (
  licensedTerritory: string,
  lotteryId: LotteryId,
) => {
  const formattedLicensedTerritory = licensedTerritory.toLowerCase()
  const formattedLotteryId = lotteryId.toLowerCase()

  const createCssVar = (suffix: string, fallback = 'unset') => {
    const lotteryAndLicensedTerritorySpecific = `--lottery-${formattedLotteryId}-${formattedLicensedTerritory}-${suffix}`
    const lotterySpecific = `--lottery-${formattedLotteryId}-${suffix}`
    return `var(${lotteryAndLicensedTerritorySpecific}, var(${lotterySpecific}, ${fallback}))`
  }

  return { createCssVar }
}

export const getLotteryIdInCorrectCase = (anyCaseLotteryId?: Maybe<string>) =>
  Object.values(LotteryId).find(
    (lotteryId) => lotteryId.toLowerCase() === anyCaseLotteryId?.toLowerCase(),
  ) ?? null

export const getLotteryNumberFields = (numbers: Numbers[]) =>
  numbers.map<LineItemField>((number) => ({
    modifies: number.modifies,
    name: number.name,
    numbers: number.values.map((value) => ({ value })),
  }))

const { width } = useWindowSize()

const DEVICE_WIDTH_THRESHOLD = 600

/**
 * Do not return `1` for one line, instead use `undefined`.
 * Otherwise the selected numbers on the options page will have visual bugs.
 */
export const getCountOfFieldRows = (
  totalFields: number,
  lottery: LotteryId,
) => {
  switch (lottery) {
    case LotteryId.MegaMillions:
    case LotteryId.PowerBall:
      // ignore extraHit
      return undefined
    case LotteryId.NewYorkPick10:
      // Results have 20 numbers
      // Orders have 10 numbers
      if (width.value > DEVICE_WIDTH_THRESHOLD)
        return totalFields === 10 ? undefined : 2

      return totalFields === 10 ? 2 : 4
    case LotteryId.TexasAllOrNothing:
      return width.value > DEVICE_WIDTH_THRESHOLD ? undefined : 2
    default:
      if (width.value > DEVICE_WIDTH_THRESHOLD) return undefined
      else if (totalFields > 18) return 4
      else if (totalFields > 12) return 3
      else if (totalFields > 7) return 2

      return undefined
  }
}
